import styled from 'styled-components';
import { Icon } from 'components/Icon';
import Panel from 'components/UI/Panel/Panel';
import SmallLabel from 'components/UI/Labels/SmallLabel';
import Headline from 'components/UI/Typography/Headline';
import DefaultText from 'components/UI/Typography/DefaultText';
import { Color } from 'modules/styles/colors';
import { BorderRadius, Spacing } from 'modules/styles/variables';
import { MuiLink, MuiTypography } from 'theme/material-ui';

export const SectionContainer = styled.div`
  align-content: center;
  flex-direction: row;
  border-color: ${Color.grayHue2};
  border-width: 1px;
  border-radius: ${BorderRadius.base};
  width: 100%;
  padding: ${Spacing.medium}px;
  margin: ${Spacing.small}px ${Spacing.none}px ${Spacing.none}px ${Spacing.none}px;
`;

export const StyledPanel = styled(Panel)`
  width: 100%;
  align-self: center;
`;

export const HelpPhoneLink = styled(MuiLink)`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const FormattingPreservingTypography = styled(MuiTypography)`
  white-space: pre-line;
`;
